import React from 'react'
import {Button, Col, Divider, Form, Input, message, Row} from "antd";
import {DeleteTwoTone} from "@ant-design/icons";

const { TextArea } = Input

const CustomerBulkAddress = ({updater}) => {

    const [form] = Form.useForm()

    const saveAddresses = ({addresses}) => updater([...addresses])

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <h4>Adresler</h4>
                </Col>
            </Row>
            <div>
                <Form name={'address-bulk'} onFinish={saveAddresses} form={form}>
                    <Form.List name={'addresses'}>
                        {(addressList, {add, remove}) => (
                            <>
                                {
                                    addressList.map(({key, name}) => {
                                        return (
                                            <div key={key}>
                                                <Row justify={'space-between'}>
                                                    <Col span={20}>
                                                        <Form.Item name={[name, 'title']}
                                                            rules={[
                                                                {required: true, message: 'Lütfen Boş Bırakmayınız'}
                                                            ]}
                                                        >
                                                            <Input placeholder={'Başlık'} onBlur={form.submit}/>
                                                        </Form.Item>
                                                        <Form.Item name={[name, 'address']}
                                                                   rules={[
                                                                       {required: true, message: 'Lütfen Boş Bırakmayınız'}
                                                                   ]}
                                                        >
                                                            <TextArea placeholder={'Adres'} onBlur={form.submit}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <DeleteTwoTone onClick={() => remove(name)} />
                                                    </Col>
                                                </Row>
                                                <Divider />
                                            </div>
                                        )
                                    })
                                }
                                <Form.Item>
                                    <Row justify={'center'}>
                                        <Button type={'link'} onClick={() => add()}>Yeni Ekle</Button>
                                    </Row>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form>
            </div>
        </React.Fragment>
    )
}
export default CustomerBulkAddress